function fn(isManual: boolean): boolean {
    return isManual;
}

export default fn;
